"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sso-page"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/no-access.jpg"),
      alt: "",
      srcset: ""
    }
  }), _c("div", {
    staticClass: "title"
  }, [_vm._v("暂无CRM访问权限")]), _c("div", [_vm._v("请联系管理员开通")])]);
}];
render._withStripped = true;